var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDuneLogoCircle = function SvgDuneLogoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4603E",
    d: "M11.993 23.981c6.623 0 11.993-5.368 11.993-11.99C23.986 5.368 18.616 0 11.993 0S.001 5.368.001 11.99c0 6.623 5.37 11.991 11.992 11.991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1870",
    d: "M2.088 18.754s7.924-2.596 21.891-7.15c0 0 .765 7.458-6.966 11.348 0 0-3.813 1.828-7.996.656 0 0-4.165-.787-6.93-4.854"
  })));
};
export default SvgDuneLogoCircle;